import axios from 'axios';  
import { getUserInstance } from './instances/user';
import {getUserBookingInstance} from './instances/booking'
import { getDashboardInstance } from './instances/dashboard'


const DEV_ENV = "development"

const devHost = process.env.REACT_APP_BE_API_URL
const prodHost = process.env.REACT_APP_BE_API_URL
const DEV_API_VERSION = process.env.REACT_APP_API_VERSION
const PROD_API_VERSION = process.env.REACT_APP_API_VERSION

const {REACT_APP_AUTH_FEAT, REACT_APP_BOOKING_FEAT} = process.env

const baseURL = process.env.NODE_ENV === DEV_ENV ? `${devHost}/${DEV_API_VERSION}`: `${prodHost}/${PROD_API_VERSION}`;
console.log(`base url ---/  https://${REACT_APP_BOOKING_FEAT}.${baseURL}`)
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

// Remove global Authorization header assignment to avoid stale tokens and ensure interceptors handle it
// Common Axios interceptor for all API instances
const setupInterceptors = (axiosInstance: any) => {
    axiosInstance.interceptors.request.use(
        (config: any) => {
            // Always fetch the latest token before each request
            const token = localStorage.getItem('accessToken');
            if (token && token !== 'undefined' && token !== 'null') {
                config.headers = config.headers || {};
                config.headers['Authorization'] = `Bearer ${token}`;
            } else {
                // Optionally, remove the Authorization header if no token is present
                if (config.headers && config.headers['Authorization']) {
                    delete config.headers['Authorization'];
                }
                console.warn('No valid token found for Authorization header');
            }
            return config;
        },
        (error: any) => Promise.reject(error)
    );

    axiosInstance.interceptors.response.use(
        (response: any) => response,
        (error: any) => {
            // Handle errors globally
            // Example: Redirect to login on 401
            // if (error.response && error.response.status === 401) {
            //   window.location.href = '/login';
            // }
            return Promise.reject(error);
        }
    );
};

const authAxios = axios.create({  
    baseURL: `https://${REACT_APP_AUTH_FEAT}.${baseURL}/auth`, // Replace with your public API base URL  
    timeout: 20000, // 10 seconds timeout  
});  

const bookingAxios = axios.create({
    baseURL:`https://${REACT_APP_BOOKING_FEAT}.${baseURL}`,
    timeout:20000, //10 seconds timeout
})

const userAxios = getUserInstance(baseURL);
const userBookingAxios = getUserBookingInstance(baseURL);
const dashboardAxios = getDashboardInstance(baseURL);
// Setup interceptors for all axios instances
[axios, authAxios, bookingAxios, userAxios, userBookingAxios, dashboardAxios].forEach(instance => {
    setupInterceptors(instance);
});


// export const getBaseURL = (serviceModule: any, serviceName: any) => {
//     console.log("https://${serviceModule}.${devHost}${DEV_API_VERSION}/${serviceName}`" , `https://${serviceModule}.${devHost}/${DEV_API_VERSION}/${serviceName}`)
//     return `https://${serviceModule}.${devHost}/${DEV_API_VERSION}/${serviceName}`
// }
// console.log("process.env" , process.env)

// Setup interceptors for all axios instances
[axios, authAxios, bookingAxios, userAxios, userBookingAxios, dashboardAxios].forEach(instance => {
    setupInterceptors(instance);
});


export const getBaseURL = (serviceModule: any, serviceName: any) => {
    // console.log("https://${serviceModule}.${devHost}${DEV_API_VERSION}/${serviceName}`" , `https://${serviceModule}.${devHost}/${DEV_API_VERSION}/${serviceName}`)
    return `https://${serviceModule}.${devHost}/${DEV_API_VERSION}/${serviceName}`
}
console.log("process.env" , process.env)

export { authAxios,bookingAxios, userAxios, userBookingAxios, dashboardAxios};
